import { Component } from '@angular/core';
import { ICON } from '@core/util/icon';

@Component({
	selector: 'app-compliance-letters',
	templateUrl: './compliance-letters.component.html',
	standalone: false,
})
export class ComplianceLettersComponent {
	public complianceStatus = [
		{ label: 'OK', value: 'ok' },
		{ label: 'Not OK', value: 'notOk' },
	];
	public ICON = ICON;
}
